/**
 * @generated SignedSource<<06f2165ee1580db94212dc69ad8707b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type contentSubmissionEnd_UserFragment$data = {
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"PrivateAddressDialog_UserFragment">;
  readonly " $fragmentType": "contentSubmissionEnd_UserFragment";
};
export type contentSubmissionEnd_UserFragment$key = {
  readonly " $data"?: contentSubmissionEnd_UserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"contentSubmissionEnd_UserFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "contentSubmissionEnd_UserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PrivateAddressDialog_UserFragment"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "47c25c55a949c6259aaf6454fb19c50f";

export default node;
